'use client';

import Link from 'next/link';
import { useLanguage } from '@/contexts/LanguageContext';
import { getCountryFlag } from '@/lib/flags';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#152a45] dark:bg-[#0f172a] text-white py-12 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-[#d4a574] rounded-lg flex items-center justify-center">
                <span className="text-[#1e3a5f] text-xl">🏢</span>
              </div>
              <div>
                <h1 className="text-xl font-bold">GCC Business Hub</h1>
              </div>
            </div>
            <p className="text-gray-300 dark:text-gray-400 mb-4">{t('footer.tagline')}</p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#d4a574] transition">
                FB
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#d4a574] transition">
                TW
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#d4a574] transition">
                LI
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#d4a574] transition">
                IG
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4 text-[#d4a574]">{t('footer.categories')}</h4>
            <ul className="space-y-2">
              <li><Link href="/category/company-formation" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">Company Formation</Link></li>
              <li><Link href="/category/legal-services" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">Legal Services</Link></li>
              <li><Link href="/category/accounting-audit" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">Accounting & Audit</Link></li>
              <li><Link href="/category/it-services" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">IT Services</Link></li>
              <li><Link href="/category/hr-recruitment" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">HR & Recruitment</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4 text-[#d4a574]">{t('footer.countries')}</h4>
            <ul className="space-y-2">
              <li><Link href="/country/BH" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">{getCountryFlag('BH')} {t('country.BH')}</Link></li>
              <li><Link href="/country/AE" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">{getCountryFlag('AE')} {t('country.AE')}</Link></li>
              <li><Link href="/country/SA" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">{getCountryFlag('SA')} {t('country.SA')}</Link></li>
              <li><Link href="/country/QA" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">{getCountryFlag('QA')} {t('country.QA')}</Link></li>
              <li><Link href="/country/KW" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">{getCountryFlag('KW')} {t('country.KW')}</Link></li>
              <li><Link href="/country/OM" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">{getCountryFlag('OM')} {t('country.OM')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4 text-[#d4a574]">{t('footer.company')}</h4>
            <ul className="space-y-2">
              <li><Link href="/about" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">{t('footer.aboutUs')}</Link></li>
              <li><Link href="/#contact" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">{t('footer.contact')}</Link></li>
              <li><Link href="/pricing" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">{t('nav.pricing')}</Link></li>
              <li><Link href="/pricing#contact" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">{t('nav.listBusiness')}</Link></li>
              <li><Link href="/privacy" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">{t('footer.privacy')}</Link></li>
              <li><Link href="/terms" className="text-gray-300 dark:text-gray-400 hover:text-[#d4a574] transition">{t('footer.terms')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-gray-400">
          <p className="mb-2">&copy; {t('footer.copyright')}</p>
          <p className="text-sm">
            {t('footer.poweredBy')} <a href="https://salahuddinss.com.bh/" target="_blank" rel="noopener noreferrer" className="text-[#d4a574] hover:text-[#e8c9a3] transition font-semibold">SSS</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
